import Link from 'launch/components/Link';
import React from 'react';

const PrivacyLink = () => (
    <Link href="/legal/privacy" target="_blank" variations={['default']}>
        {__('Privacy')}
    </Link>
);

export default PrivacyLink;
